import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight, Package, Shield, BarChart3, Ban } from 'lucide-react';

const AmazonRegistrySection = ({ onOpenContactForm }) => {
  return (
    <section data-testid="amazon-registry-section" className="py-28 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-[#3B82F6]/[0.04] rounded-full blur-[100px]" />
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="glass-card rounded-2xl p-8 md:p-12 border-[#3B82F6]/10 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-[#3B82F6]/[0.06] rounded-full blur-[80px]" />
          <div className="relative z-10">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-6">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#3B82F6]/10 border border-[#3B82F6]/20">
                  <Package className="w-3.5 h-3.5 text-[#3B82F6]" />
                  <span className="text-xs font-semibold text-[#3B82F6] uppercase tracking-wider">Amazon Sellers</span>
                </div>
                <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-white">
                  Amazon Brand Registry <span className="text-gradient">Requires a Trademark</span>
                </h2>
                <p className="text-[#A1A1AA] leading-relaxed">
                  To enroll in Amazon Brand Registry, you need a registered trademark or pending USPTO application. Our service handles the complete process from trademark filing to Brand Registry enrollment.
                </p>
                <Button data-testid="amazon-cta" onClick={onOpenContactForm}
                  className="btn-gradient text-white font-semibold px-7 py-3 rounded-lg border-0">
                  Start Amazon Brand Registry <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>

              <div className="space-y-4">
                <h3 className="font-heading text-lg font-semibold text-white mb-4">Brand Registry Benefits:</h3>
                {[
                  { icon: Shield, title: 'Brand Protection', desc: 'Automated protection against counterfeits and unauthorized sellers on Amazon.' },
                  { icon: BarChart3, title: 'Listing Control', desc: 'Full control over your product listings with A+ Content, Sponsored Brands, and Brand Analytics.' },
                  { icon: Ban, title: 'Counterfeit Prevention', desc: 'Report violations, remove counterfeit listings, and protect your brand reputation.' },
                ].map((benefit) => (
                  <div key={benefit.title} className="flex gap-4 p-4 rounded-xl bg-white/[0.03] border border-white/[0.04] hover:border-[#3B82F6]/20 hover:bg-white/[0.06] transition-all duration-300 hover:translate-x-1 cursor-default">
                    <div className="w-10 h-10 rounded-lg bg-[#3B82F6]/10 flex items-center justify-center shrink-0">
                      <benefit.icon className="w-5 h-5 text-[#3B82F6]" />
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-white mb-1">{benefit.title}</h4>
                      <p className="text-xs text-[#A1A1AA] leading-relaxed">{benefit.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AmazonRegistrySection;
